import { useEffect, useState } from "react";
import { getApi } from "./api";
import type { AuthenticatedUser } from "./types";

export const getAccessToken = (): Promise<string | undefined> => getApi().getAccessToken();
export const getUser = (): Promise<AuthenticatedUser | undefined> => getApi().getUser();

/** Returns undefined while loading, when signed out, or if loading fails. */
export const useUser = (): AuthenticatedUser | undefined => {
  const [user, setUser] = useState<AuthenticatedUser>();

  useEffect(() => {
    let active = true;
    void getUser()
      .then((authenticatedUser) => {
        if (active) setUser(authenticatedUser);
      })
      .catch(() => {
        // Leave the user undefined when the authenticated user cannot be loaded.
      });
    return () => {
      active = false;
    };
  }, []);

  return user;
};

/** Returns false until the authenticated user's permissions are available. */
export const useUserHasPermission = (permission: string): boolean => {
  const user = useUser();
  return user?.roles.includes(permission) ?? false;
};
